'use client';
import {useEffect, type RefObject} from 'react';
import {observeBiteScreen} from '@/lib/bite-screen-observation';
import {trackBiteScreen} from '@/lib/bite-measurement';
export function useBiteScreen(root:RefObject<HTMLElement|null>, enabled:boolean, type:string, identity:string, metadata:Record<string,unknown>={}) {
  const details=JSON.stringify(metadata);
  useEffect(()=>{
    if(!enabled||!root.current)return;
    const element=root.current;
    const observe=()=>observeBiteScreen(element,()=>trackBiteScreen(type,identity,JSON.parse(details)));
    let stop=observe();
    const changed=()=>{stop();stop=observe();};
    window.addEventListener('bite-consent-change',changed);
    window.addEventListener('bite:measurement-ready',changed);
    window.addEventListener('storage',changed);
    return()=>{stop();window.removeEventListener('bite-consent-change',changed);window.removeEventListener('bite:measurement-ready',changed);window.removeEventListener('storage',changed);};
  },[root,enabled,type,identity,details]);
}
